import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './WallpaperCategoryNav.module.less';

export default memo(({ list = [], handleCategory, active, text, keyId, keyName }) => {
  if (list.length < 1) {
    return null;
  }
  return (
    <div className={styles.label_container}>
      <div className={styles.label_row_class}>
        <div className={classNames(styles.grid_item_start)}>{text}：</div>
        <div
          className={classNames(styles.grid_item_second, {
            [styles.active]: active === (list[0] && list[0][keyId]),
          })}
        >
          <span onClick={handleCategory(list[0] && list[0][keyId])}>
            {list[0] && list[0][keyName]}
          </span>
        </div>
      </div>
      {list.length > 1 && (
        <div className={styles.label_row_content}>
          {list.map((item, index) => {
            if (index !== 0) {
              return (
                <div
                  key={item[keyId]}
                  className={classNames(styles.label_item, {
                    [styles.active]: active === item[keyId],
                  })}
                >
                  <div onClick={handleCategory(item[keyId])}>
                    {item.colorValue && (
                      <div
                        className={styles.label_color_block}
                        style={{ backgroundColor: item.colorValue }}
                      />
                    )}
                    <span>{item[keyName]}</span>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
});
